import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  PageHeader,
  Button,
  Divider,
  Form,
  Input,
  message,
  Upload,
  Select,
  Switch,
  Checkbox,
} from "antd";

import * as settingAPI from "../../../api/setting";

import {
  CloseOutlined,
  CheckOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";

function BasicSettingPage({ isEdit }) {
  const forms = [
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
  ];

  const [ipForm] = Form.useForm();

  const navigate = useNavigate();
  const params = useParams();

  const [loading, setLoading] = useState(true);
  const [setting, setAdmin] = useState(null);

  const [image, setImage] = useState(null);

  const fetchAdmin = () => {
    settingAPI
      .getConfigs({ page: 1, size: 100 })
      .then((res) => {
        if (res.data.linusCode === 1) {
          setAdmin(res.data.data);
          setLoading(false);
        } else {
          alert(res.data.data.msg);
        }
      })
      .catch((error) => {
        if (error.response.data.detail) {
          message.error(error.response.data.detail);
        } else if (error.response.status < 500) {
          for (let key of Object.keys(error.response.data)) {
            message.error(`${key}: ${error.response.data[key]}`);
          }
        } else {
          message.error("오류가 발생했습니다.");
        }
      });
  };

  useEffect(() => {
    fetchAdmin();
  }, []);

  return (
    <>
      <div>
        <PageHeader
          className="site-page-header"
          title={`기본 설정`}
          subTitle={`작성 후 저장 버튼을 눌러주세요.`}
        />
        <Divider />
        {loading && <></>}
      </div>
      {!loading && (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {setting
              //   .filter((i) => i.name !== "ipAllow")
              .map((i, idx) => {
                return (
                  <Form
                    form={forms[idx]}
                    name={i.name}
                    initialValues={i}
                    scrollToFirstError
                    style={{ width: "50%" }}
                    onFinish={(val) => {
                      settingAPI
                        .editConfig({ id: i.id, ...val })
                        .then((res) => {
                          if (res.data.linusCode === 1) {
                            message.success("성공적으로 반영되었습니다.");
                          }
                        });
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <Form.Item
                        name="value"
                        label={i.desc}
                        style={{
                          width: "500px",
                        }}
                      >
                        <TextArea
                          placeholder={`${i.desc}를 입력해주세요.`}
                          rows={5}
                        />
                      </Form.Item>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          marginLeft: "10px",
                        }}
                      >
                        <Form.Item>
                          <Button
                            type="primary"
                            htmlType="submit"
                            icon={<CheckOutlined />}
                          >
                            저장
                          </Button>
                        </Form.Item>
                      </div>
                    </div>
                  </Form>
                );
              })}
          </div>
        </>
      )}
    </>
  );
}

export default BasicSettingPage;
